import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";

import Select2 from "../../../../components/common/select/Select2";
import Typeahead from "../../../../components/common/typeahead/Typeahead";
import DatePicker2 from "../../../../components/common/datepicker/DatePicker2";
import { Field } from "redux-form";
import { required, date } from "../../../../utils/forms/validators";
import styles from "./FilterBox.scss";

const dateVal = date("Please enter a valid Date.");

const CATEGORIES = [
  { id: 1, value: "Status" },
  // { id: 2, value: 'Location' }, removed since it's not implemented on the BE yet
  { id: 3, value: "Last Activity Date" },
  { id: 4, value: "TSS Admin" },
  { id: 7, value: "Budget Type" },
  { id: 13, value: "Project Submitted" },
  { id: 8, value: "Project Approved" },
  { id: 9, value: "Project Start Date" },
  { id: 10, value: "Project End Date" },
  { id: 6, value: "Must Skill" },
  { id: 11, value: "Nice Skill" },
  { id: 5, value: "Must Skill Category" },
  { id: 12, value: "Nice Skill Category" }
];

class FilterBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: -1
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.selected !== this.state.selectedCategory) {
      this.setState({ selectedCategory: this.props.selected });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected !== this.state.selectedCategory) {
      this.setState({ selectedCategory: nextProps.selected });
    }
  }

  onChange(value) {
    this.setState({ selectedCategory: value });
  }

  getSkillsByCategory() {
    let allSkills = [];
    this.props.skillsOptions.forEach(skill => {
      allSkills = allSkills.concat(skill.skills);
    });

    const category = this.props.selectedSkillCategory[
      this.props.selectedSkillCategory.length - 1
    ];
    if (!category || category < 0)
      return allSkills.map(skill => ({ ...skill, value: skill.name }));
    const filtered = this.props.skillsOptions.filter(s => s.id == category);
    if (!filtered || filtered.length <= 0) return [];

    return filtered[0].skills.map(skill => ({ ...skill, value: skill.name }));
  }

  getTSSAdmins() {
    const admins = this.props.tssAdminOptions;
    if (!admins) return [];
    const mapped = admins.map(a => {
      return { id: a.id, value: `${a.first_name} ${a.last_name}` };
    });
    return mapped;
  }

  renderStatus() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.status_id`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.props.statusOptions}
      />
    );
  }

  renderBudgetTypes() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.budget_rate_type_id`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.props.budgetOptions}
      />
    );
  }

  renderLocation() {
    return (
      <Field
        name={`${this.props.inputName}.location`}
        placeholder="Criteria"
        component={Typeahead}
        onSearch={query => this.props.onSearchCities(query)}
        isLoading={this.props.isLoadingCities}
        options={this.props.cities}
        isAsync={true}
        minLength={3}
        allowNew={false}
        labelKey="description"
        valueKey="id"
        selected={this.props.selectedLocation}
        icon="map-marker"
      />
    );
  }

  renderActivityDate() {
    return (
      <div>
        <Col xs={12} md={6} className={styles.noPadLeft}>
          <Field
            name={`${this.props.inputName}.last_activity_after`}
            placeholder="From"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
        <Col xs={12} md={6} className={styles.noPadHorizontal}>
          <Field
            name={`${this.props.inputName}.last_activity_before`}
            placeholder="To"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
      </div>
    );
  }

  renderMustSkillsCategories() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.must_skill_category`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.props.skillsCategoriesOptions.map(skill => ({
          ...skill,
          value: skill.name
        }))}
      />
    );
  }

  renderNiceSkillsCategories() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.nice_skill_category`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.props.skillsCategoriesOptions.map(skill => ({
          ...skill,
          value: skill.name
        }))}
      />
    );
  }

  renderMustSkills() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.must_skill`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.getSkillsByCategory()}
      />
    );
  }

  renderNiceSkills() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.nice_skill`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.getSkillsByCategory()}
      />
    );
  }

  renderTSSAdmin() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.admin_id`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.getTSSAdmins()}
      />
    );
  }

  renderProjectSubmitted() {
    return (
      <div>
        <Col xs={12} md={6} className={styles.noPadLeft}>
          <Field
            name={`${this.props.inputName}.submitted_after`}
            placeholder="From"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
        <Col xs={12} md={6} className={styles.noPadHorizontal}>
          <Field
            name={`${this.props.inputName}.submitted_before`}
            placeholder="To"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
      </div>
    );
  }

  renderProjectApproved() {
    return (
      <div>
        <Col xs={12} md={6} className={styles.noPadLeft}>
          <Field
            name={`${this.props.inputName}.approved_after`}
            placeholder="From"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
        <Col xs={12} md={6} className={styles.noPadHorizontal}>
          <Field
            name={`${this.props.inputName}.approved_before`}
            placeholder="To"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
      </div>
    );
  }

  renderProjectStartDate() {
    return (
      <div>
        <Col xs={12} md={6} className={styles.noPadLeft}>
          <Field
            name={`${this.props.inputName}.start_after`}
            placeholder="From"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
        <Col xs={12} md={6} className={styles.noPadHorizontal}>
          <Field
            name={`${this.props.inputName}.start_before`}
            placeholder="To"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
      </div>
    );
  }

  renderProjectEndDate() {
    return (
      <div>
        <Col xs={12} md={6} className={styles.noPadLeft}>
          <Field
            name={`${this.props.inputName}.end_after`}
            placeholder="From"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
        <Col xs={12} md={6} className={styles.noPadHorizontal}>
          <Field
            name={`${this.props.inputName}.end_before`}
            placeholder="To"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
      </div>
    );
  }

  renderCriteria() {
    switch (this.state.selectedCategory) {
      case 1:
        return this.renderStatus();
      case 2:
        return this.renderLocation();
      case 3:
        return this.renderActivityDate();
      case 4:
        return this.renderTSSAdmin();
      case 5:
        return this.renderMustSkillsCategories();
      case 6:
        return this.renderMustSkills();
      case 7:
        return this.renderBudgetTypes();
      case 8:
        return this.renderProjectApproved();
      case 9:
        return this.renderProjectStartDate();
      case 10:
        return this.renderProjectEndDate();
      case 11:
        return this.renderMustSkillsCategories();
      case 12:
        return this.renderNiceSkillsCategories();
      case 13:
        return this.renderProjectSubmitted();
      default:
        return null;
    }
  }

  render() {
    return (
      <Row>
        <Col xs={12} md={5}>
          <Field
            validate={required}
            name={this.props.name}
            type="select"
            placeholder="Category"
            component={Select2}
            options={CATEGORIES}
            onSelectChange={this.onChange}
          />
        </Col>
        <Col xs={12} md={7}>
          {this.renderCriteria()}
        </Col>
      </Row>
    );
  }
}

export default FilterBox;



// WEBPACK FOOTER //
// ./src/routes/admin/projects/components/FilterBox.js